import { useState, useRef } from 'react';
import { FormControl, InputLabel, Select, MenuItem, Checkbox, FormLabel, FormGroup, FormControlLabel } from '@mui/material';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import { useRecoilValue } from 'recoil';

import TranslationText from '@Components/Utilities/TranslationText';
import TextField from '@Components/Shared/Controls/TextField'
import atoms from '@Components/Utilities/SandhillsAtoms';
import { insertURLParameter } from '@Components/Utilities/SandhillsUtility';

const CharterFlightSearch = (props) => {
    const aircraftTypes = ['Jet', 'Turboprop', 'Piston', 'Helicopter'];
    const inputReferences = useRef({});
    const [formData, setFormData] = useState({ TypeOfFlight: [], Distance: '', });
    const distanceOptions = [10, 20, 50, 150, 200];
    const routes = useRecoilValue(atoms.routes);
    const [error, setError] = useState('');

    const AircraftTypes = {
        'JET': 3,
        'TURBOPROP': 8,
        'PISTON': [6, 9],
        'HELICOPTER': [5, 7]
    };

    const setFlightType = (e) => {
        const value = e.target.value;
        setFormData(previousState => {
            const newTypeOfFlight = previousState.TypeOfFlight.includes(value)
                ? previousState.TypeOfFlight.filter(type => type !== value)
                : [...previousState.TypeOfFlight, value];
            return { ...previousState, TypeOfFlight: newTypeOfFlight };
        });
    }

    const onAirportChange = (e) => {
        let id = e.target.id;
        let value = e.target.value;
        setFormData(previousState => {
            return { ...previousState, [id]: { AirportCodeDisplay: value } };
        });
    }

    const setDistance = (e) => {
        setFormData(previousState => {
            return { ...previousState, Distance: e.target.value };
        });
    }

    const getAutoCompleteUrl = (e, url) => {
        return url;
    };

    const getAutoCompleteData = (e) => {
        return {
            text: e.target.value
        };
    };

    const flightSearch = (e) => {
        e.preventDefault();
        let url = props.searchURL;

        if (formData.TypeOfFlight.length > 0) { 
            const aircraftTypeNumbers = formData.TypeOfFlight.flatMap(type => AircraftTypes[type.toUpperCase()]);
            url = insertURLParameter(url, 'Category', aircraftTypeNumbers.join('|'));
        }      
        
        if (formData.Distance !== '') {  
            if (formData.CharterSearchCityAirportCode?.AirportCityID > 0) {
                url = insertURLParameter(url, 'CityID', formData.CharterSearchCityAirportCode.AirportCityID);
            }
            else if (formData.CharterSearchCityAirportCode?.AirportCodeID > 0) {
                url = insertURLParameter(url, 'AirportID', formData.CharterSearchCityAirportCode.AirportCodeID);
            }
            else {
                setError('Invalid City/Airport. Select value from dropdown or remove airport and distance.');
                return;
            }

            url = insertURLParameter(url, 'Distance', formData.Distance);  
        }

        window.location.href = url;
    };

    return (
        <>
            {error && <div className='error' style={{ fontSize: '12px' }}>{error}</div>}
            <div className='button-input aircraft-selector'>
                <FormLabel className='drilldown-header' component="legend">{<TranslationText tKey='sandhills.typeofaircraft' />}:</FormLabel>
                <FormGroup aria-label="position" name="aircraft-selector-radio-group" value={formData.TypeOfFlight} onChange={setFlightType} row>
                    {aircraftTypes.map((name) => (
                        <FormControlLabel
                            value={name}
                            control={<Checkbox />}
                            label={name}
                            labelPlacement="end"
                        />
                    ))}
                </FormGroup>
            </div>
            <div className='form-row'>
                <div className='boxed-input airport-selector'>
                    <FlightTakeoffIcon className='material-icon' />
                    <TextField
                        id='CharterSearchCityAirportCode'
                        name='CharterSearchCityAirportCode'
                        label={<TranslationText tKey='sandhills.tradesites.mvc.cityairportfrom' />}
                        value={formData.CharterSearchCityAirportCode?.AirportCodeDisplay}
                        type='text'
                        required
                        ref={(element) => inputReferences.current[`CharterSearchCityAirportCode`] = element}
                        updateField={(value, airportcodeid, cityid) => setFormData(previousState => {
                            return { ...previousState, CharterSearchCityAirportCode: { AirportCodeID: airportcodeid, AirportCityID: cityid, AirportCodeDisplay: value } };
                        })}
                        onFieldChanged={onAirportChange}
                        autoComplete={{
                            ajaxUrl: (e) => getAutoCompleteUrl(e, routes.GetCityAirportCodeAutoComplete),
                            postData: (e) => getAutoCompleteData(e)
                        }}
                        useMUI
                        InputProps={{
                            disableUnderline: true
                        }}
                    />
                </div>
                <div className='boxed-input aircraft-selector'>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="distance-select-label" className='shrink-label'><TranslationText tKey='sandhills.tradesites.mvc.distancefromairport' /></InputLabel>
                        <Select
                            labelId="distance-select-label"
                            id="distance-select"
                            value={formData.Distance}
                            label={translator.translate('sandhills.tradesites.mvc.distancefromairport')}
                            onChange={setDistance}
                            inputProps={{
                                id: 'distance-select-label'
                            }}
                        >
                            <MenuItem value=""><em>None</em></MenuItem>  
                            {distanceOptions.map((name) => (
                                <MenuItem value={name}>{name} {props.IsMetric ? translator.translate('sandhills.tradepubwebsite.mvc.kilometersabrv') : translator.translate('sandhills.tradepubwebsite.mvc.miles')}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <input className='ts-button submit-button button' type='submit' id='request-a-charter-submit-button' name='request-a-charter-submit-button' value={translator.translate('sandhills.tradepubwebsite.mvc.submit')} onClick={flightSearch} />
            </div>
        </>
    );
}

    export default CharterFlightSearch;